export * from './esm/index'

import pkg from './package.json'
console.log(`[${pkg.name}] v${pkg.version} loaded`)
